import React from 'react';
import { Badge } from '@/shadcn/components/ui/badge';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/shadcn/components/ui/tooltip';

interface TagsDisplayProps {
  tags: string[];
  tagsVisible: string[];
  className?: string;
}

export const TagsDisplay: React.FC<TagsDisplayProps> = ({ tags, tagsVisible, className }) => {
  if (tags.length === 0) return null;
  return (
    <div className={`flex flex-wrap items-center gap-1${className ? ` ${className}` : ''}`}>
      {tagsVisible.map((tag) => (
        <Badge key={tag} variant="outline" className="text-xs px-2 py-1 bg-muted text-muted-foreground border-border">
          {tag}
        </Badge>
      ))}
      {tagsVisible.length < tags.length && (
        <Tooltip>
          <TooltipTrigger>
            <Badge variant="outline" className="text-xs px-2 py-1 bg-muted text-muted-foreground border-border">
              +{tags.length - tagsVisible.length}
            </Badge>
          </TooltipTrigger>
          <TooltipContent
            side="bottom"
            align="end"
            collisionPadding={16}
            className="max-w-[250px] max-h-[50vh] overflow-y-auto z-50"
            sideOffset={5}
          >
            <p className="break-words">{tags.slice(tagsVisible.length).join(', ')}</p>
          </TooltipContent>
        </Tooltip>
      )}
    </div>
  );
};
